import { NavigationEnd, Router } from '@angular/router';
import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, UntypedFormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { DynamicFormGroupService } from 'src/app/services/dynamic-form-group.service';
@Component({
  selector: 'calsoft-price-table-plan',
  templateUrl: './price-table-plan.component.html',
  styleUrls: ['./price-table-plan.component.scss']
})
export class PriceTablePlanComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';

  url = '';

  priceForm: FormGroup;
  formData:any;
  btntext:string;
  @Output() setData = new EventEmitter<any>();
  @Input() priceplandata: any;
  
  constructor(private fb: FormBuilder, private snackBar: MatSnackBar,
    private dynamicFormGroupService: DynamicFormGroupService, private router: Router) {
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }

  ngOnInit() {
    this.createForm();
    this.populateForm();
    this.getdynamicForm();
    this.getdynamicFormList();
  }

  
  getdynamicForm() {
    this.getdynamicFormList();
    this.dynmaicFormYFilter();
    this.getAlldynamicForm();
  }

  populateForm() {
    if (this.priceplandata) {
      const pricedetailFormArray = this.priceForm.get('pricedetail') as FormArray;
  
      while (pricedetailFormArray.length !== 0) {
        pricedetailFormArray.removeAt(0);
      }
  
      this.priceplandata.forEach((detail: any) => {
        const detailFormGroup = this.fb.group({
          title: detail.title,
          list_detail: this.fb.array([])
        });
  
        const listDetailFormArray = detailFormGroup.get('list_detail') as FormArray;
  
        detail.list_detail.forEach((item: any) => {
          const listItemFormGroup = this.fb.group(item);
          listDetailFormArray.push(listItemFormGroup);
        });
  
        pricedetailFormArray.push(detailFormGroup);
      });
      this.btntext = 'Update';
    }
  }
  

  navigation: any = [
    { viewValue: 'Link', value: 1 },
    { viewValue: 'ID', value: 0 },
    { viewValue: 'Form', value: 2 },
  ];

  createForm() {
    this.priceForm = this.fb.group({
      pricedetail: this.fb.array([])
    });

    // Initialize form with empty values
    this.addPricingDetails();
    this.btntext = 'Submit';
  }

  get pricedetail(): FormArray {
    return this.priceForm.get('pricedetail') as FormArray;
  }

  addPricingDetails() {
    this.pricedetail.push(this.fb.group({
      title: '',
      list_detail: this.fb.array([])
    }));

    // You can initialize with default values if needed
    this.addListDetail(this.pricedetail.length - 1);
  }

  addListDetail(index: number) {
    const listDetail = this.pricedetail.at(index).get('list_detail') as FormArray;
    
    listDetail.push(this.fb.group({
      sub_title: '',
      starter: '',
      profession: '',
      advanced: '',
      navigation:[1],
      button_name:'',
      button_link:'',
      value:'',
      id_element:'',
      table_color:[''],
    }));
  }

  deletePricingDetail(index: number) {
    this.pricedetail.removeAt(index);
  }

  deleteListDetail(detailIndex: number, listIndex: number) {
    const listDetail = this.pricedetail.at(detailIndex).get('list_detail') as FormArray;
    listDetail.removeAt(listIndex);
    this.emit();
   
  }

  onSubmit() {
    this.formData = this.priceForm.value.pricedetail.map((detail) => {
      return {
        title: detail.title,
        list_detail: detail.list_detail.map((item) => {
          return {
            sub_title: item.sub_title,
            starter: item.starter,
            profession: item.profession,
            advanced: item.advanced,
            button_name: item.button_name,
            button_link: item.button_link,
            navigation:item.navigation,
            value:item.value,
            id_element:item.id_element,
            table_color:item.table_color,
          };
        })
      };
    });
    this.emit();
  }

  emit(){
    // this.setData.emit(this.pricedetail.value);

    this.setData.emit(this.formData)
    console.log(this.formData);
    
  }


  //contact form

  protected _onDestroy = new Subject<void>();

  dynamicFormTypeList: any;
  filtereddynamicFormTypeList: any;

  public dynamicFormFilterControl: UntypedFormControl = new UntypedFormControl();

  dynamicFormList: any;
  getdynamicFormList() {
      this.dynamicFormGroupService.getAllDynmaicFormDropDown(1).subscribe(
          (res) => {
              this.dynamicFormList = res;
              this.dynamicFormTypeList = this.dynamicFormList;
              this.filtereddynamicFormTypeList = this.dynamicFormTypeList;
          },
          (error) => { }
      );
  }

  dynmaicFormYFilter() {
      this.dynamicFormFilterControl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
              this.dynamicFilter();
          });
  }

  protected dynamicFilter() {
      if (!this.dynamicFormTypeList) {
          return;
      }
      let search = this.dynamicFormFilterControl.value;
      if (!search) {
          this.filtereddynamicFormTypeList = this.dynamicFormTypeList.slice();
          return;
      } else {
          search = search.toLowerCase();
      }

      this.filtereddynamicFormTypeList = this.dynamicFormTypeList.filter(
          (dynamicForm) => dynamicForm['name'].toLowerCase().indexOf(search) > -1
      );
  }

  getAlldynamicForm() {
      this.filtereddynamicFormTypeList = this.dynamicFormTypeList;
  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
